import { computed as u, openBlock as i, createElementBlock as s, normalizeClass as l, createElementVNode as d, renderSlot as z, createVNode as k, createBlock as h, createCommentVNode as y, toDisplayString as S, Fragment as E, renderList as C } from "vue";
import L from "../../atoms/highlighted-title/highlighted-title.vue.js";
import { themeProp as A, themeOptions as r } from "../../composables/useTheme.js";
import B from "../../molecules/breadcrumbs/breadcrumbs.vue.js";
import N from "../../molecules/eyebrow/eyebrow.vue.js";
import $ from "../../molecules/link-back/link-back.vue.js";
import j from "../../molecules/link/link.vue.js";
/* empty css          */
import O from "../../_virtual/_plugin-vue_export-helper.js";
import f from "../../constants/size.js";
import v from "../../constants/screen.js";
const F = { class: "ds-grid" }, I = {
  key: 0,
  class: "ds-margin-bottom-48"
}, R = { class: "ds-grid__col ds-grid__col--12 ds-lg-grid__col--7 ds-grid__col--no-gutter" }, V = {
  key: 2,
  class: "ds-buttons-wrapper ds-margin-top-24"
}, x = "left", H = "center", T = /* @__PURE__ */ Object.assign({
  name: "DsHero"
}, {
  __name: "hero",
  props: {
    ...A,
    /**
     * Hero eyebrow
     */
    eyebrow: {
      type: String,
      default: ""
    },
    /**
     * Hero title
     */
    title: {
      type: String,
      required: !0
    },
    /**
     * Hero text
     */
    text: {
      type: String,
      default: ""
    },
    /**
     * Hero navigation data, link back or breadcrumbs
     */
    navigationData: {
      type: [Object, Array],
      default: null,
      validator: (t) => Array.isArray(t) ? t.every((n, m, o) => m === o.length - 1 ? "title" in n : ["title", "url"].every((g) => g in n)) : ["text", "url"].every((n) => n in t)
    },
    /**
     * Hero links,
     * array of links with properties:
     * @property {String} title - link title
     * @property {String} url - link href value
     * @property {Boolean} openInNewWindow - open the link in a new window (optional)
     * @property {Boolean} nuxt - renders as nuxt link (optional)
     * @property {String} type - link look (optional)
     * @property {String} theme - link theme (optional)
     * @property {Object} iconLeft - icon (optional)
     * @property {Object} iconRight - icon (optional)
     * @property {String} lazyUrlEndpoint - icon (optional)
     */
    links: {
      type: Array,
      default: () => [],
      validator: (t) => t.every((n) => n && n.title !== void 0 && n.url !== void 0)
    },
    /**
     * Hero alignment
     * Possible values are: 'left' and 'center'.
     */
    alignment: {
      type: String,
      default: x,
      validator: (t) => [x, H].includes(t)
    },
    /**
     * Hero title size, optional.
     * renders the title in a bigger font size.
     */
    withTitleSizeLarge: {
      type: Boolean,
      default: !1
    },
    colClasses: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const n = t, m = u(() => n.links.length ? n.links[0].type === "button" ? "ds-md-margin-right-24" : "ds-md-margin-right-12" : ""), o = u(() => n.alignment === "center"), g = u(() => {
      const e = n.withTitleSizeLarge ? f.xlarge : f.large;
      return {
        [v.small.name]: f.large,
        [v.medium.name]: e,
        [v.large.name]: e
      };
    }), D = u(() => Array.isArray(n.navigationData)), c = (e) => {
      switch (e) {
        case "light":
        case "grey":
          return "white";
        case "dark":
          return "black";
        default:
          return "green";
      }
    }, w = (e) => {
      const p = [r.light, r.grey];
      return n.theme === r.dark && e === r.dark ? c(r.light) : p.includes(n.theme) && e === r.light ? c(r.dark) : n.theme === r.green && (e === r.green || !e) ? c(r.dark) : c(e);
    };
    return (e, p) => (i(), s("section", {
      class: l(["ds-hero", `ds-hero--${e.theme}`])
    }, [
      d("div", {
        class: l(["ds-container ds-padding-y-48", [
          {
            "ds-md-padding-y-96": !t.navigationData,
            "ds-md-padding-bottom-96": t.navigationData
          }
        ]])
      }, [
        d("div", F, [
          d("div", {
            class: l(["ds-grid__col ds-grid__col--12", t.colClasses])
          }, [
            z(e.$slots, "eyebrow", {}, () => [
              k(N, {
                text: t.eyebrow,
                theme: e.theme,
                class: l({ "ds-justify-content-center": o.value })
              }, null, 8, ["text", "theme", "class"])
            ], !0),
            t.navigationData ? (i(), s("div", I, [
              D.value ? (i(), h(B, {
                key: 1,
                theme: e.theme,
                crumbs: t.navigationData,
                "tracking-data": { "component-name": e.$options.name, title: t.title }
              }, null, 8, ["theme", "crumbs", "tracking-data"])) : (i(), h($, {
                key: 0,
                theme: e.theme,
                "tracking-data": { "component-name": e.$options.name, text: t.navigationData.text, title: t.title },
                text: t.navigationData.text,
                url: t.navigationData.url,
                nuxt: t.navigationData.nuxt,
                "lazy-url-endpoint": t.navigationData.lazyUrlEndpoint
              }, null, 8, ["theme", "tracking-data", "text", "url", "nuxt", "lazy-url-endpoint"]))
            ])) : y("", !0),
            k(L, {
              text: t.title,
              theme: e.theme,
              size: g.value,
              class: l(["ds-hero__title", { "ds-text-align-center": o.value }])
            }, null, 8, ["text", "theme", "size", "class"]),
            t.text ? (i(), s("div", {
              key: 1,
              class: l(["ds-margin-top-24 ds-grid", { "ds-display-flex ds-justify-content-center": o.value }])
            }, [
              d("div", R, [
                d("p", {
                  class: l(["ds-text-medium", { "ds-text-align-center": o.value }]),
                  "data-j-text": ""
                }, S(t.text), 3)
              ])
            ], 2)) : y("", !0),
            t.links.length > 0 ? (i(), s("div", V, [
              (i(!0), s(E, null, C(t.links, (a, b) => (i(), h(j, {
                key: `link-${b}`,
                "tracking-data": { "component-name": e.$options.name, text: a.title, title: t.title },
                type: a.type,
                content: a.title,
                "icon-left": a.iconLeft,
                "icon-right": a.iconRight,
                url: a.url,
                "lazy-url-endpoint": a.lazyUrlEndpoint,
                color: w(a.theme),
                "open-in-new-window": a.openInNewWindow,
                nuxt: a.nuxt,
                class: l(m.value)
              }, null, 8, ["tracking-data", "type", "content", "icon-left", "icon-right", "url", "lazy-url-endpoint", "color", "open-in-new-window", "nuxt", "class"]))), 128))
            ])) : y("", !0)
          ], 2)
        ])
      ], 2)
    ], 2));
  }
}), Y = /* @__PURE__ */ O(T, [["__scopeId", "data-v-e20c9dbd"]]);
export {
  Y as default
};
